namespace Matrix.Data {
    export interface FieldCustomizationForm {
        RowCode: Serenity.StringEditor;
        FieldName: Serenity.LookupEditor;
        DisplayName: Serenity.StringEditor;
        Alias: Serenity.StringEditor;
        RemoveField: Serenity.BooleanEditor;
        IsRequired: Serenity.YesNoCheckEditor;
        Insertable: Serenity.YesNoCheckEditor;
        Updatable: Serenity.YesNoCheckEditor;
        Cloneable: Serenity.YesNoCheckEditor;
        VisibleInForm: Serenity.YesNoCheckEditor;
        FormTab: Serenity.StringEditor;
        FormCategory: Serenity.StringEditor;
        FormWidth: FormWidthEditor;
        LabelWidth: Serenity.StringEditor;
        DefaultValue: Serenity.StringEditor;
        MaxLength: Serenity.IntegerEditor;
        DecimalPlaces: Serenity.IntegerEditor;
        EditorType: Serenity.LookupEditor;
        VisibleInGrid: Serenity.YesNoCheckEditor;
        EditLink: Serenity.YesNoCheckEditor;
        Width: Serenity.IntegerEditor;
        Alignment: AlignmentStringEditor;
        QuickSearchType: Serenity.EnumEditor;
        DisplayFormat: Serenity.StringEditor;
        FormatterType: Serenity.LookupEditor;
        ReadPermission: Serenity.StringEditor;
        ModifyPermission: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class FieldCustomizationForm extends Serenity.PrefixedContext {
        static formKey = 'Data.FieldCustomization';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FieldCustomizationForm.init)  {
                FieldCustomizationForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.YesNoCheckEditor;
                var w4 = FormWidthEditor;
                var w5 = s.IntegerEditor;
                var w6 = AlignmentStringEditor;
                var w7 = s.EnumEditor;
                var w8 = StaticTextBlock;
                var w9 = ReadOnlyDateTime;

                Q.initFormType(FieldCustomizationForm, [
                    'RowCode', w0,
                    'FieldName', w1,
                    'DisplayName', w0,
                    'Alias', w0,
                    'RemoveField', w2,
                    'IsRequired', w3,
                    'Insertable', w3,
                    'Updatable', w3,
                    'Cloneable', w3,
                    'VisibleInForm', w3,
                    'FormTab', w0,
                    'FormCategory', w0,
                    'FormWidth', w4,
                    'LabelWidth', w0,
                    'DefaultValue', w0,
                    'MaxLength', w5,
                    'DecimalPlaces', w5,
                    'EditorType', w1,
                    'VisibleInGrid', w3,
                    'EditLink', w3,
                    'Width', w5,
                    'Alignment', w6,
                    'QuickSearchType', w7,
                    'DisplayFormat', w0,
                    'FormatterType', w1,
                    'ReadPermission', w0,
                    'ModifyPermission', w0,
                    'CreatedBy', w8,
                    'CreatedWhen', w9,
                    'UpdatedBy', w8,
                    'UpdatedWhen', w9,
                    'Version', w8
                ]);
            }
        }
    }
}
